export enum ImportExportSubject {
  DatapoolRecords = 'datapoolRecords',
  Inference = 'inference',
}
